import React, { useState } from "react";
import cx from "classnames";
import { Field, Form, Formik } from "formik";
import { CurrencyField } from "forms/fields";
import PropTypes from "prop-types";
import Delete from "rialto-icons/Delete";
import Edit from "rialto-icons/Edit";

import FormActions from "components/FormActions";
import hoverable from "components/hoc/hoverable";
import Price from "components/Price";
import { confirm, Translate } from "utils";

import styles from "./FeePotential.css";

const { t } = new Translate("EnquiryHeader");

const FeePotential = (props) => {
  const [isEdit, setIsEdit] = useState(false);
  const { defaultCurrency, feePotential, isHovered, onUpdate } = props;
  const hasFeePotential = feePotential && !!feePotential.value;

  const handleCancel = () => {
    setIsEdit(false);
  };

  const handleDelete = () => {
    confirm(() => {
      onUpdate(null);
      setIsEdit(false);
    }, t("confirm.feePotentialRemove"));
  };

  const handleEdit = () => {
    setIsEdit(true);
  };

  const handleUpdate = (values) => {
    onUpdate(values.feePotential);
    setIsEdit(false);
  };

  return (
    <div className={cx(styles.FeePotential, { [styles.hovered]: isHovered })}>
      {isEdit && (
        <Formik
          initialValues={{
            feePotential: feePotential || { currency: defaultCurrency },
          }}
          onSubmit={handleUpdate}
        >
          {() => (
            <Form>
              <Field component={CurrencyField} name="feePotential" />
              <FormActions onCancel={handleCancel} isEdit isHovered isSaveable withIcon />
            </Form>
          )}
        </Formik>
      )}

      {!isEdit && hasFeePotential && (
        <>
          <Price price={feePotential} />
          <div className={styles.editActions}>
            <button className={styles.btn} onClick={handleEdit}>
              <Edit size="small" />
            </button>
            <button className={styles.btn} onClick={handleDelete}>
              <Delete size="small" />
            </button>
          </div>
        </>
      )}
      {!isEdit && !hasFeePotential && (
        <button className={cx(styles.btn, { [styles.new]: !hasFeePotential })} onClick={handleEdit}>
          {`+ ${t("assignFeePotential")}`}
        </button>
      )}
    </div>
  );
};

FeePotential.propTypes = {
  feePotential: PropTypes.shape({
    value: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }),
  defaultCurrency: PropTypes.string,
  isHovered: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
};

export default hoverable(FeePotential);
